const CheckIcon = ({
  width = 10,
  height = 8,
  color = "currentColor",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='4 0 10 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13 1L7.5 7L5 4.27273'
      fill='none'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default CheckIcon;
